import {useGetProductInCart} from 'hooks/product/useGetProductInCart';
import {ProductBuyMobileCartButton} from 'modules/product-card/components/ProductBuyMobileCartButton';
import {ProductBuyMobileCartCounter} from 'modules/product-card/components/ProductBuyMobileCartCounter';
import {FC} from 'react';

export const ProductBuyMobileCart: FC = () => {
    const productInCart = useGetProductInCart();

    if (productInCart) {
        return <ProductBuyMobileCartCounter />;
    }

    return <ProductBuyMobileCartButton />;
};
